// Status subscription system
const subscribers = new Map();

/**
 * Subscribe to status updates for a specific item
 * @param {string} itemId The ID of the item to subscribe to
 * @param {Function} callback Callback function to invoke when status changes
 * @returns {Function} Unsubscribe function
 */
export const subscribeToStatus = (itemId, callback) => {
  if (!subscribers.has(itemId)) {
    subscribers.set(itemId, new Set());
    console.log(`[Subscribers] Created new subscriber set for item ${itemId}`);
  }
  
  subscribers.get(itemId).add(callback);
  console.log(`[Subscribers] Added subscriber to item ${itemId}, total subscribers: ${subscribers.get(itemId).size}`);
  
  // Return an unsubscribe function
  return () => {
    console.log(`[Subscribers] Unsubscribing from item ${itemId}`);
    const itemSubscribers = subscribers.get(itemId);
    if (itemSubscribers) {
      itemSubscribers.delete(callback);
      console.log(`[Subscribers] Removed subscriber from item ${itemId}, remaining subscribers: ${itemSubscribers.size}`);
      if (itemSubscribers.size === 0) {
        subscribers.delete(itemId);
        console.log(`[Subscribers] Removed empty subscriber set for item ${itemId}`);
      }
    }
  };
};

/**
 * Notify subscribers about status updates
 * @param {string} itemId The ID of the item with updated status
 * @param {Object} status The updated status information
 */
export const notifySubscribers = (itemId, status) => {
  if (subscribers.has(itemId)) {
    const subscriberCount = subscribers.get(itemId).size;
    console.log(`[Subscribers] Notifying ${subscriberCount} subscribers for item ${itemId} with status:`, status);
    
    subscribers.get(itemId).forEach(callback => {
      try {
        callback(status);
      } catch (error) {
        console.error(`[Subscribers] Error in subscriber callback for item ${itemId}:`, error);
      }
    });
  } else {
    console.log(`[Subscribers] No subscribers found for item ${itemId}`);
  }
};

/**
 * Check if an item has subscribers
 * @param {string} itemId The ID of the item to check
 * @returns {boolean} Whether the item has subscribers
 */
export const hasSubscribers = (itemId) => {
  const hasSubscribers = subscribers.has(itemId);
  console.log(`[Subscribers] Checking subscribers for item ${itemId}: ${hasSubscribers ? 'has subscribers' : 'no subscribers'}`);
  return hasSubscribers;
}; 